import {
  TopicPage,
  getStaticPathsForTopicIndexPage,
  getStaticPropsForTopicIndexPage,
} from '@marketing-sites/blog-components/components/TopicPage'

export const getStaticProps = getStaticPropsForTopicIndexPage
export const getStaticPaths = getStaticPathsForTopicIndexPage

export default TopicPage
